import React from "react";
import styled from "styled-components";

const ContactUs = () => {
  return (
    <Section>
      <Container>

        {/* SECTION HEADING */}
        <HeadingBox>
          <Title>Contact Us</Title>
          <SubTitle>Thoughtfully curated gifts for every moment.
Reach out and let us create something unforgettable.</SubTitle>
        </HeadingBox>

        <ContentWrapper>
          {/* LEFT SIDE → BLACK CARD */}
          <LeftCard>
            <div className="content">
              {/* <h3>HEAD OFFICE</h3> */}

              <div className="info">
                <span>📍</span>
                <p>
                  #306, Hubtown Solaris, NS Phadke Marg,<br />
                  Near East West Flyover, Andheri (E),<br />
                  Mumbai, India
                </p>
              </div>

              <div className="info">
                <span>✉️</span>
                <p>gifttoinspire@gmail.com</p>
              </div>

              <div className="info">
                <span>📞</span>
                <p>+91 22 61164444</p>
              </div>

              <div className="info">
                <span>📱</span>
                <p>+91 9820700011</p>
              </div>

              <div className="info">
                <span>💬</span>
                <p>+91 9820700011</p>
              </div>
            </div>
          </LeftCard>

          {/* RIGHT SIDE → MAP */}
          <RightMap>
            <iframe
              title="office-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30272.870650568765!2d72.844391!3d19.118719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c82f3ee1e3b1%3A0xf8a84dea89fa1c00!2sAndheri%20East%2C%20Mumbai!5e0!3m2!1sen!2sin!4v1700000000000"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </RightMap>
        </ContentWrapper>
      </Container>
    </Section>
  );
};

export default ContactUs;

/* ---------------- STYLED COMPONENTS ---------------- */

const Section = styled.div`
  width: 100%;
  background: #f5f1eaff; /* soft cream */
  padding: 35px 0;
`;

const Container = styled.div`
  width: 75%;
  max-width: 1400px;
  margin: auto;
`;

const HeadingBox = styled.div`
  text-align: left;
  margin-bottom: 40px;
`;

const Title = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: #1c1c1c;
  position: relative;
  width: fit-content;

  &:after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 4px;
    background: #d2a65c; /* gold underline */
    border-radius: 4px;
  }
`;

const SubTitle = styled.h3`
  margin-top: 25px;
  color: #555;
  font-weight: 400;
  font-size: 14px;
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 30px;

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
  }
`;

const LeftCard = styled.div`
  background: #0f0f0f; 
  color: #fff;
  border-radius: 16px;
  padding: 50px 40px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.25);
  border-top: 12px solid #d2a65c;

  .content {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .info {
    display: flex;
    gap: 18px;
    align-items: flex-start;
    transition: 0.2s ease;

    span {
      font-size: 16px;
    }

    p {
      margin: 0;
      font-size:14px;
      line-height: 1.2;
      color: #e8e8e8;
    }

    &:hover p {
      color: #ffffff;
      transform: translateX(3px);
    }
  }
`;

const RightMap = styled.div`
  border-radius: 16px;
  overflow: hidden;
  height: 480px;
  // max-width: 750px; 
  box-shadow: 0 20px 40px rgba(0,0,0,0.18);
  transform: translateY(0);
  transition: 0.3s ease;

  &:hover {
    transform: translateY(-4px);
  }

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }

  @media (max-width: 900px) {
    height: 400px;
  }
`;




